import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import Tooltip from 'LuxKit/Tooltip'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useLocalizedBreadcrumbs } from 'hooks/usePlace'

const TEXT_LIMITER = 16

const DesktopRelatedItems = styled.ul`
  list-style-type: none;
  margin: 0;
  align-items: center;
  height: 100%;
  width: 100%;
  display: none;

  ${mediaQueryUp.tablet} {
    display: flex;
    flex: 1;
  }

  .tooltip_content {
    padding: ${rem(4)} ${rem(8)} ${rem(4)} ${rem(8)};
  }

  > * + * {
    margin-inline-start: ${rem(4)};
  }

  > li {
    display: inline-flex;
    align-items: center;

    > * + * {
      margin-inline-start: ${rem(4)};
    }
  }
`

const StyledLink = styled(TextLink)`
  display: block;
  white-space: nowrap;
`

function truncateString(s: string | null | undefined, maxLen: number = TEXT_LIMITER) {
  if (!s) {
    return ''
  }

  if (s.length > maxLen) {
    return ''.concat(s.slice(0, maxLen), '...')
  }
  return s
}

interface Props {
  offer?: App.Offer | App.BedbankOffer
  relatedTravelItems?: Array<App.BreadcrumbItem>
}

function DesktopRelatedTravelItems({ relatedTravelItems = EmptyArray }: Props) {
  const localizedItems = useLocalizedBreadcrumbs(relatedTravelItems)
  if (localizedItems.length === 0) {
    return null
  }

  return <DesktopRelatedItems>
    {localizedItems.map((item, index) => {
      const text = truncateString(item.text)
      return <li key={index}>
        {index > 0 && <LineAngleRightIcon size="XS" />}

        {item.url && item.text?.length <= TEXT_LIMITER && <StyledLink title={item.text} weight="regular" size="caption" to={item.url}>
          {text}
        </StyledLink>}
        {item.url && item.text?.length > TEXT_LIMITER && <Tooltip
          placement="bottom"
          description={item.text}
        >
          <StyledLink title={item.text} weight="regular" size="caption" to={item.url}>
            {text}
          </StyledLink>
        </Tooltip>}

        {!item.url && item.text?.length <= TEXT_LIMITER && <Caption wrap="no-wrap" variant="medium">
          {text}
        </Caption>}
        {!item.url && item.text?.length > TEXT_LIMITER && <Tooltip
          placement="bottom"
          description={item.text}
        >
          <Caption wrap="no-wrap" variant="medium" title={item.text}>
            {text}
          </Caption>
        </Tooltip>}
      </li>
    })}
  </DesktopRelatedItems>
}

function mapStateToProps(state: App.State, ownProps: Props) {
  return {
    relatedTravelItems: ownProps.relatedTravelItems ?? state.offer.relatedTravelItems[ownProps.offer?.id ?? ''],
  }
}

export default connect(mapStateToProps)(DesktopRelatedTravelItems)
